<template>
  <Layout>
    <div class="card">
      <div class="card-body">
        <PageHeader :title="title" :items="items" />

        <vue-good-table
          ref="tblExpedientes"
          mode="remote"
          @on-page-change="onPageChange"
          @on-sort-change="onSortChange"
          @on-column-filter="onColumnFilter"
          @on-per-page-change="onPerPageChange"
          @on-search="onSearch"
          :totalRows="totalRecords"
          :isLoading.sync="isLoading"
          :pagination-options="{
            enabled: true
          }"
          :rows="rows"
          :columns="columns"
          :globalSearch="true"
          @on-row-dblclick="onRowDoubleClick"
          styleClass="vgt-table smalltable fixfont"
          :search-options="{
            enabled: true,
            //trigger: 'enter',
            skipDiacritics: true,
            placeholder: 'buscarEnTabla'
          }"
          :select-options="{
            selectOnCheckboxOnly: true,
            enabled: true,
            selectionText: 'Filas seleccionadas',
            clearSelectionText: 'Borrar'
          }"
          :sort-options="{
          enabled: false,
          }"
        >
          <template slot="table-row" slot-scope="props">

            <span v-if="props.column.field == 'tipo_expediente'">
              <a href="javascript:void(0);" v-on:click="mostrarModal(props.row.id)">{{props.row.tipo_expediente}}</a>
            </span>
            <span v-else-if="props.column.field == 'denominacion'">
              <a href="javascript:void(0);" v-on:click="mostrarEstudiante(props.row)">{{props.row.denominacion}}</a>
            </span>

            <span v-else-if="props.column.field == 'archivos'">

              <div
                      v-for="(data, index) in props.row.archivos"
                      v-bind:key="index"
                      style="float:left"
              >
                <a :href="server + '/storage/' + data.nombre" target="_blank" v-b-tooltip.top ="data.nombre_original" >
                  <i
                          class="mdi mdi-cloud-download ml-1"
                          style="font-size: 20px;color: #000000"
                  /></a>
              </div>
            </span>
            <span v-else class="fixfont">
              {{ props.formattedRow[props.column.field] }}
            </span>
          </template>

          <div slot="table-actions">

          </div>
        </vue-good-table>

        <b-modal
                id="modalExpediente"
                scrollable
                title="Expediente"
                title-class="font-18"
                size="xl"
        >
          <ExpedienteInfo :modal="modal" />

        </b-modal>

        <b-modal
                id="modalEstudiante"
                scrollable
                title="Estudiante"
                title-class="font-18"
                size="lg"
        >
          <EstudianteInfo :data="estudiante" />
        </b-modal>

      </div>
    </div>
  </Layout>
</template>

<script>
import Layout from "../../layouts/main";
import appConfig from "@/app.config";
import PageHeader from "@/components/page-header";
import ExpedienteInfo from '@/components/expediente-info'
import EstudianteInfo from '@/components/estudiante-info'

/**
 * Dashboard Component
 */
export default {
  page: {
    title: "Recepción de expedientes",
    meta: [{ name: "description", content: appConfig.description }]
  },
  components: {
    Layout,
    PageHeader,
    ExpedienteInfo,
    EstudianteInfo

  },
  data() {
    return {
      razonRechazo:"",
      title: "Expedientes tramitados",
      items: [
        {
          text: "Expedientes",
          href: "/"
        },
        {
          text: "Tramitados",
          active: true
        }
      ],

      isLoading: false,
      columns: [
        {
          label: "Nº Exp",
          field: "numero_referencia"
        },
        {
          label: "Tramite",
          field:"tipo_expediente"
        },
        {
          label: "Nombre / Denominacion",
          field: "denominacion"
        },
        {
          label: "Carrera",
          field: "carrera"
        },
        {
          label: "Codigo",
          field: "codigo"
        },
        {
          label: "Archivos",
          field: "archivos"
        }

      ],
      rows: [],
      totalRecords: 0,
      serverParams: {
        columnFilters: {},
        sort: {
          field: "",
          type: ""
        },
        page: 1,
        perPage: 10
      },
      server: process.env.VUE_APP_BACKEND,
      modal:{},
      estudiante:{}
    };
  },

  methods: {
    updateText(texto){
      console.log(texto);
      this.razonRechazo=texto;
    },
    mostrarEstudiante(row){
      this.isLoading=true;
      this.estudiante={};
      this.axios.get(
              process.env.VUE_APP_BACKEND + "/api/estudiantes/buscar", {
                params: {
                  codigo:row.codigo,
                  codigo_carrera:row.codigo_carrera
                }
              }
      )
              .then((response)=>{
                this.estudiante=response.data;
                this.$bvModal.show("modalEstudiante");
              })
              .finally(()=>{
                this.isLoading=false;
              })
    },

    decimal(value) {
      if (value === null) {
        return "-";
      } else {
        return parseFloat(value).toFixed(2);
      }
    },
    onSearch: function(params) {
      this.updateParams({ page: params.page });
      this.updateParams({ searchTerm: params.searchTerm });
      this.loadItems();
    },
    say: function(message) {
      alert(message);
    },
    updateParams(newProps) {
      this.serverParams = Object.assign({}, this.serverParams, newProps);
    },

    onPageChange(params) {
      this.updateParams({ page: params.currentPage });
      this.loadItems();
    },

    onPerPageChange(params) {
      this.updateParams({ perPage: params.currentPerPage });
      this.loadItems();
    },

    onSortChange(params) {
      this.updateParams({
        sort: [
          {
            type: params.sortType,
            field: this.columns[params.columnIndex].field
          }
        ]
      });
      this.loadItems();
    },

    onColumnFilter(params) {
      this.updateParams(params);
      this.loadItems();
    },
    // load items is what brings back the rows from server
    loadItems() {
      this.isLoading = true;
      this.axios
        .get(process.env.VUE_APP_BACKEND + "/api/expedientes/tabla-expedientes-tramitados", {
          params: this.serverParams
        })
        .then(response => {
          //console.log(response.data.data);
          this.totalRecords = response.data.total_records;
          this.rows = response.data.data;
          this.isLoading = false;
        })
        .catch(() => {
          this.isLoading = false;
          //console.log(error);
        });
    },
    /* eslint-disable */
    onRowDoubleClick(params) {
      //this.$bvModal.show("modalExpediente");
      this.mostrarModal(params.row.id);
    },
    mostrarModal(expediente_id){
      this.isLoading=true;
      this.axios.get( process.env.VUE_APP_BACKEND +'/api/expedientes/'+expediente_id)
              .then((response)=>{
                this.modal=response.data;
                this.$bvModal.show("modalExpediente");
              }).finally(()=>this.isLoading=false);

    },

     /* eslint-enable */
  },
  mounted() {
    this.loadItems();
  }
};
</script>

<style>
.fixfont {
  font-size: 13px !important;
  color: #000000 !important;
}
</style>
